// Utilities to format dates according to selected locale
export function getSelectedLocale() {
  try {
    const stored = localStorage.getItem('selectedLocale');
    if (stored) return stored;
    // fallback to window initial or 'es'
    if (typeof window !== 'undefined' && window.__INITIAL_LOCALE__) return window.__INITIAL_LOCALE__;
  } catch (e) {}
  return 'es';
}

function pad(n) { return String(n).padStart(2, '0'); }

export function formatDate(value) {
  if (!value) return '';
  try {
    const locale = getSelectedLocale();
    let d;
    // handle numeric timestamps (seconds or milliseconds) or numeric strings
    if (typeof value === 'number') {
      // if seconds (10 digits) convert to ms
      d = value > 1e12 ? new Date(value) : new Date(value * 1000);
    } else if (/^\d{10}$/.test(String(value))) {
      d = new Date(Number(value) * 1000);
    } else if (/^\d{13}$/.test(String(value))) {
      d = new Date(Number(value));
    } else {
      d = new Date(value);
    }
    if (isNaN(d.getTime())) return value;

    if (locale && locale.startsWith('es')) {
      // Spanish: dd/mm/yy
      const yy = String(d.getFullYear()).slice(2);
      return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${yy}`;
    }

    // default: ISO-like date YYYY-MM-DD
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
  } catch (e) {
    return value;
  }
}

export function formatDateTime(value, withSeconds = false) {
  if (!value) return '';
  try {
    const locale = getSelectedLocale();
    let d;
    if (typeof value === 'number') {
      d = value > 1e12 ? new Date(value) : new Date(value * 1000);
    } else if (/^\d{10}$/.test(String(value))) {
      d = new Date(Number(value) * 1000);
    } else if (/^\d{13}$/.test(String(value))) {
      d = new Date(Number(value));
    } else {
      d = new Date(value);
    }
    if (isNaN(d.getTime())) return value;

    const day = pad(d.getDate());
    const month = pad(d.getMonth() + 1);
    const yearShort = String(d.getFullYear()).slice(2);
    const yearFull = d.getFullYear();
    const hh = pad(d.getHours());
    const mm = pad(d.getMinutes());
    const ss = pad(d.getSeconds());

    if (locale && locale.startsWith('es')) {
      // dd/mm/yy HH:MM
      return `${day}/${month}/${yearShort} ${hh}:${mm}` + (withSeconds ? `:${ss}` : '');
    }

    // default: YYYY-MM-DD HH:MM
    return `${yearFull}-${month}-${day} ${hh}:${mm}` + (withSeconds ? `:${ss}` : '');
  } catch (e) {
    return value;
  }
}

export default { formatDate, formatDateTime, getSelectedLocale };
